export class State {
	mobile: boolean;
	mobileTabletPortrait: boolean;
	tabletPortrait: boolean;
	tabletLandscape: boolean;
	desktop: boolean;
}

export const initialState: State = {
	mobile: false,
	mobileTabletPortrait: false,
	tabletPortrait: false,
	tabletLandscape: false,
	desktop: false
};
